import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { CurrentUserProfile } from "types/user";

const useCurrentUserProfile = (): CurrentUserProfile | null => {
  return useSelector((state: RootState) => state.auth.currentUserProfile);
};

export default useCurrentUserProfile;
